export enum ListClickEvents {
  ListClick = "list_click",
  FaqClick = "faq_click",
}

export type ListItemAnchor = {
  title: string;
  path?: string;
  tabBehaviour?: "sameTab" | "newTab";
};
